import { apiClient } from "../../../lib";
import {
    ContractorState,
    ContractorCard,
    ContractorRank,
    ContractorGraph
} from "../contractorTypes";

export const contractorApi = {

    fetchState: async (params: Record<string, any>): Promise<ContractorState> => {
        const response = await apiClient.get<{ status: boolean; data: ContractorState; message?: string }>("/contractor/stats", { params });
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch region details");
        }
        return response.data.data;
    },

    fetchCards: async (params: Record<string, any>): Promise<ContractorCard[]> => {
        const response = await apiClient.get<{ status: boolean; data: { total_contractors: number; contractors: ContractorCard[] }; message?: string }>("/contractor/cards", { params });
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor cards");
        }
        return response.data.data.contractors;
    },

    fetchRankList: async (params: Record<string, any>): Promise<ContractorRank[]> => {
        const response = await apiClient.get<{ status: boolean; data: ContractorRank[]; message?: string }>("/contractor/rank-list", { params });
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor rank list");
        }
        return response.data.data;
    },

    fetchGraph: async (params: Record<string, any>): Promise<ContractorGraph> => {
        const response = await apiClient.get<{ status: boolean; data: ContractorGraph; message?: string }>("/contractor/graph", { params });
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor graph");
        }
        return response.data.data;
    }
    
};

export const contractorDetailsApi = {

    fetchContractorDetails: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor details");
        }
        return response.data.data;
    },

    fetchPerformanceTrend: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor/performance-trend?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor performance trend");
        }
        return response.data.data;
    },

    fetchCommercialView: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor/commercial-view?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor commercial view");
        }
        return response.data.data;
    },

    fetchRegionalBreakdown: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor/regional-breakdown?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor regional breakdown");
        }
        return response.data.data;
    },

    fetchDeliverySnapshot: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor/delivery-snapshot?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor delivery snapshot");
        }
        return response.data.data;
    },

    fetchRiskAndWarning: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor/risk-and-warning?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor risk and warning");
        }
        return response.data.data;
    },

    fetchResourceReliability: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor/resource-reliability?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor resource reliability");
        }
        return response.data.data;
    },

    fetchActivityList: async (contractorId: string | null): Promise<any> => {
        const response = await apiClient.get<{ status: boolean; data: any; message?: string }>(`/contractor/activity-list?contractor_id=${contractorId}`);
        if (!response.data.status || !response.data.data) {
            throw new Error(response.data.message || "Failed to fetch contractor activity list");
        }
        return response.data.data;
    },

};